export * from './actionStore'

export const BASE_URL = process.env.REACT_APP_ENDPOINT
export const BASE_URL_STRIPE = `${BASE_URL}/stripe`
